/** Pure helpers for the Team page (unit-testable). */

export interface TeamMemberLike {
  user_id: string;
  role: string;
}

/**
 * True when the given member is the only owner of the restaurant, so demoting
 * or removing them would trip the database's last-owner guard (errcode 23514).
 */
export function isLastOwner(members: readonly TeamMemberLike[], userId: string): boolean {
  const owners = members.filter((member) => member.role === 'owner');
  return owners.length === 1 && owners[0]?.user_id === userId;
}
